export default __webpack_public_path__ + "static/media/HushPuppies.a06b43bb.png";